import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { ShieldCheck, ChevronLeft, MessageCircle } from "lucide-react";
import { POLICIES, fillLegal } from "@/lib/policies";
import { useSettings } from "@/context/SettingsContext";
import { supportWaLink } from "@/lib/api";

export default function PolicyPage() {
  const { slug } = useParams();
  const s = useSettings();
  const policy = POLICIES[slug];
  if (!policy) return <Navigate to="/" replace />;

  const render = (block, i) => {
    if (block.type === "h") return <h2 key={i} className="font-head text-lg sm:text-xl font-black text-white mt-8 mb-3">{fillLegal(block.text, s)}</h2>;
    if (block.type === "list") return (
      <ul key={i} className="space-y-2 mb-3">
        {block.items.map((it, j) => (
          <li key={j} className="flex gap-2 text-sm text-[var(--text-muted)] leading-relaxed">
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--amber)]" />
            <span>{fillLegal(it, s)}</span>
          </li>
        ))}
      </ul>
    );
    return <p key={i} className="text-sm text-[var(--text-muted)] leading-relaxed mb-3">{fillLegal(block.text, s)}</p>;
  };

  const highlight = slug === "returns";

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10">
      <nav className="flex items-center gap-1 text-xs text-[var(--text-muted)] mb-5">
        <Link to="/" className="hover:text-[var(--amber)]">الرئيسية</Link><ChevronLeft size={12} />
        <span className="text-white">{policy.title}</span>
      </nav>

      <div className={`ts-card p-6 sm:p-9 ${highlight ? "amber-glow" : ""}`}>
        <div className="flex items-center gap-3 mb-4">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--amber)]/10 text-[var(--amber)]"><ShieldCheck size={22} /></span>
          <h1 className="font-head text-2xl sm:text-3xl font-black text-white">{policy.title}</h1>
        </div>
        {policy.intro && <p className="text-[var(--text-muted)] leading-relaxed mb-2 border-r-2 pr-3" style={{ borderColor: "var(--amber)" }}>{fillLegal(policy.intro, s)}</p>}
        <div className="mt-4">{policy.sections.map(render)}</div>

        <div className="mt-8 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: "var(--border-c)" }}>
          <p className="text-xs text-[var(--text-subtle)]">{s.platform_name} · {s.address}</p>
          <a data-testid="policy-support-whatsapp" href={supportWaLink()} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl bg-[#25D366] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#1ebe57] shrink-0">
            <MessageCircle size={16} /> دعم واتساب
          </a>
        </div>
      </div>
    </div>
  );
}
